<script setup lang="ts">
import { ref, onMounted } from 'vue'
import BatchTypeHeader from '@/components/features/batches/tab-content/BatchTypeHeader.vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import { RouterLink } from 'vue-router'
import { Icon } from '@iconify/vue'
import type { Supplier } from '@/types/supplier-types'
import { getSupplierList } from '@/api/suppliers'
import { formatedDate } from '@/constants'
import { getBatchById } from "@/api/batches"
import {getProductList} from "@/api/products";

const props = defineProps<{
  batchList: any
}>()

const suppliers = ref<Supplier[]>()
const batchNumbers = ref<Map<string, string>>(new Map())
const productsList = ref<any[]>([])

const loadBatchNumber = async (previousBatchId: string) => {
  if (!batchNumbers.value.has(previousBatchId)) {
    const batch = await getBatchById(previousBatchId)
    batchNumbers.value.set(previousBatchId, batch.batchNumber?.toString() || '-')
  }
}

const getQuality = (id: string) => {
  return productsList.value.find((product: { id: string }) => product.id === id)?.finishedReference
}

onMounted(async () => {
  suppliers.value = await getSupplierList()
  for (const batch of props.batchList) {
    if (batch.previousBatchId) {
      await loadBatchNumber(batch.previousBatchId)
    }
  }
  productsList.value = await getProductList()
})
</script>

<template>
  <BatchTypeHeader
      title="Dispatched"
      description="Find batches where all rolls have been shipped out and are no longer in stock."
  />

  <DataTable :value="batchList" class="px-0">
    <Column field="batchNumber" header="Batch Number">
      <template #body="slotProps">
        <RouterLink
            :to="`/batches/dispatched-batches-details/${slotProps.data.id}`"
            class="font-medium text-neutral-800 block hover:underline"
        >
          {{ slotProps.data.batchNumber }}
        </RouterLink>
      </template>
    </Column>
    <Column field="quality" header="Quality">
      <template #body="slotProps">
        <span>{{ getQuality(slotProps.data.finishingQualityId) }}</span>
      </template>
    </Column>
    <Column field="numberOfRolls" header="Number of Rolls">
      <template #body="slotProps">
        <span>{{ slotProps.data.returnedRolls?.length || 0 }}</span>
      </template>
    </Column>
    <Column field="dateDispatched" header="Date Dispatched">
      <template #body="slotProps">
        <span>{{ formatedDate(slotProps.data.dateDispatched) }}</span>
      </template>
    </Column>
    <Column field="action">
      <template #body="slotProps">
        <RouterLink
            :to="`/batches/dispatched-batches-details/${slotProps.data.id}`"
            class="flex items-center gap-x-2 group hover:text-primary-default"
        >
          <span>More details</span>
          <Icon
              icon="mdi:arrow-right"
              class="text-2xl group-hover:translate-x-2 transition-transform text-gray-500"
          />
        </RouterLink>
      </template>
    </Column>
  </DataTable>
</template>
